<div class="page-container">
  <div class="page-title">
    <h1 *ngIf="!isCadastrarEstabelecimentosActive()">Cadastrar empresa</h1>
    <h1 *ngIf="isCadastrarEstabelecimentosActive()">Cadastrar endereço</h1>
  </div>

  <div class="navigation-actions">
    <div class="tab-buttons">
      <button
        [ngClass]="{'active-tab': isCadastrarDadosGeraisActive()}"
        (click)="changeActiveScreen(CADASTRAR_DADOS_GERAIS)"
      >
        Dados gerais
      </button>
      <button
        [ngClass]="{'active-tab': isListarEnderecosActive() || isCadastrarEstabelecimentosActive()}"
        (click)="changeActiveScreen(LISTAR_ESTABELECIMENTOS)"
        [disabled]="!empresaSalva"
      >
        Endereços
      </button>
    </div>

    @if(this.podeCadastrarEndereco()) {
    <button
      matButton="filled"
      *ngIf="isListarEnderecosActive()"
      (click)="adicionarEndereco()"
    >
      <span class="icon-plus">+</span> Adicionar endereço
    </button>
    }
  </div>

  <div class="content-area">
    <!-- Tela de Dados Gerais -->
    <form [formGroup]="empresaForm" *ngIf="isCadastrarDadosGeraisActive()">
      <app-cadastrar-empresa-dados-gerais
        [dadosCompartilhados]="dadosCompartilhados"
      ></app-cadastrar-empresa-dados-gerais>
    </form>

    <!-- Tela de Listagem de Estabelecimentos -->
    <app-empresa-listar-estabelecimentos
      *ngIf="isListarEnderecosActive()"
      [dadosCompartilhados]="dadosCompartilhados"
    ></app-empresa-listar-estabelecimentos>

    <!-- Tela de Cadastro de Endereço/Estabelecimento -->
    <app-cadastrar-endereco
      *ngIf="isCadastrarEstabelecimentosActive()"
      [dadosCompartilhados]="dadosCompartilhados"
    ></app-cadastrar-endereco>
  </div>
</div>
